module.exports = __webpack_public_path__ + "img/not-authorized-dark.4ff6e713.svg";